import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { allowOnlyDigits } from '../digits.util';
import { PhilInputComponent } from '../../../common-components/phil-input/phil-input.component';
import { IRecoveryState, IRecoveryStepDef, RecoveryStepKey } from '../sso-login.models';

@Component({
  selector: 'app-recovery-setup',
  templateUrl: './recovery-setup.component.html',
  styleUrls: ['./recovery-setup.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, PhilInputComponent],
})
export class RecoverySetupComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) recovery!: IRecoveryState;
  @Input() steps: IRecoveryStepDef[] = [];
  @Input() isLoading = false;
  @Input() isPasswordVisible = false;

  @Output() stepSelected = new EventEmitter<number>();
  @Output() skipped = new EventEmitter<void>();
  @Output() finished = new EventEmitter<void>();
  @Output() passwordSet = new EventEmitter<void>();
  @Output() otpSent = new EventEmitter<void>();
  @Output() otpVerified = new EventEmitter<void>();
  @Output() otpCancelled = new EventEmitter<void>();

  readonly allowOnlyDigits = allowOnlyDigits;

  get emailControl(): FormControl {
    return this.form.get('email') as FormControl;
  }

  get phoneControl(): FormControl {
    return this.form.get('phone') as FormControl;
  }

  isSet(key: RecoveryStepKey): boolean {
    return this.recovery.done[key];
  }

  anySet(): boolean {
    return this.recovery.done.password || this.recovery.done.email || this.recovery.done.phone;
  }
}
